import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import { isPresent } from '@ember/utils';
export default EmberDataBaseFragment.extend({
  intl: service(),
  pan: attr('string'),
  brand: attr('string'),
  lastFour: attr('string'),
  expirationMonth: attr('string'),
  expirationYear: attr('string'),
  securityCode: attr('string'),
  postalCode: attr('string'),
  cardholderName: attr('string'),
  unitToken: attr('string'),
  token: attr('string'),
  display: attr('string'),
  digitalWalletType: attr('number'),
  type: alias('brand'),
  expirationYYMM: computed('expirationMonth', 'expirationYear', function () {
    return this.expirationYear + this.expirationMonth;
  }),
  currentPaymentMethod: computed('type', 'lastFour', 'display', function () {
    if (isPresent(this.display)) {
      return this.display;
    }
    return this.intl.t('subscriptions.sub2.paymentMethods.card.statement', {
      type: this.type,
      lastFour: this.lastFour
    });
  }),
  currentPaymentMethodShort: computed('type', 'lastFour', 'display', function () {
    if (isPresent(this.display)) {
      return this.display;
    }
    return this.intl.t('subscriptions.sub2.paymentMethods.card.statementShort', {
      type: this.type,
      lastFour: this.lastFour
    });
  })
}).reopenClass({
  _modelNameForMigration: 'subscription-card'
});